import { useQuery } from "convex/react";

import { api } from "@convex/_generated/api";

export type CreditStatus = "loading" | "ready" | "empty" | "negative";

export interface CreditBalance {
  balance: string;
  status: CreditStatus;
}

export function useCreditBalance(): CreditBalance {
  const result = useQuery(api.treasury.userBalance);
  if (result === undefined) return { balance: "0", status: "loading" };
  if (result === null) return { balance: "0", status: "empty" };
  const num = Number(result.balanceCredits);
  if (!Number.isFinite(num) || num === 0) {
    return { balance: result.balanceCredits, status: "empty" };
  }
  if (num < 0) {
    return { balance: result.balanceCredits, status: "negative" };
  }
  return { balance: result.balanceCredits, status: "ready" };
}
